export type NewsletterSource = 'homepage' | 'footer'

export async function subscribeToNewsletter({
  email,
  source,
  website,
}: {
  email: string
  source: NewsletterSource
  website?: string
}) {
  const response = await fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, source, website }),
  })

  if (!response.ok) {
    throw new Error('Newsletter subscription failed')
  }
}
